import { map, reduce } from 'ramda'

import SimpleDate from 'app/common/classes/simple-date'

const studentNameColumnWidth = 160 as const
const studentClassColumnWidth = 140 as const
const totalColumnWidth = 140 as const

export enum ColumnKey {
  StudentName = 'studentName',
  StudentClassTitle = 'studentClassTitle',
  Total = 'total',
}

export const createDinamicColumnKey = (date: SimpleDate) => {
  return `date_${date.getStringFormatted('YYYY-MM-DD')}`
}

export const columnKeysLeft = [ColumnKey.StudentName, ColumnKey.StudentClassTitle]
export const columnKeysLeftHeaders = [[ColumnKey.StudentName, ColumnKey.StudentClassTitle]]

export const createColumnKeysMain = (dates: Array<SimpleDate>) => {
  return dates.map((date) => createDinamicColumnKey(date))
}

export const createColumnKeysMainHeaders = (dates: Array<SimpleDate>) => {
  return [createColumnKeysMain(dates)]
}

export const columnKeysRight = [ColumnKey.Total]
export const columnKeysRightHeaders = [[ColumnKey.Total]]

const headerCells = {
  [ColumnKey.StudentName]: 'ФИО',
  [ColumnKey.StudentClassTitle]: 'Класс',
  [ColumnKey.Total]: 'Всего, {currency}',
}

export const createHeaderCells = (
  dates: Array<SimpleDate>,
  periodType: 'monthly' | 'daily',
  currency: string,
) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = date.getStringFormatted(periodType === 'monthly' ? 'MMMM YYYY' : 'DD.MM')
      return acc
    },
    map<Record<string, string>, Record<string, string>>(
      (value) => value.replace('{currency}', currency),
      headerCells,
    ),
    dates,
  )
}

const headerCellsProps = {
  [ColumnKey.StudentName]: { alignLeft: true, width: studentNameColumnWidth, bgFilled: true },
  [ColumnKey.StudentClassTitle]: {
    alignCenter: true,
    width: studentClassColumnWidth,
    bgFilled: true,
  },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth, bgFilled: true },
}

export const createHeaderCellsProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true, bgFilled: true }
      return acc
    },
    headerCellsProps,
    dates,
  )
}

const cellsProps = {
  [ColumnKey.StudentName]: { alignLeft: true, width: studentNameColumnWidth },
  [ColumnKey.StudentClassTitle]: { alignCenter: true, width: studentClassColumnWidth },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth },
}

export const createCellsProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true }
      return acc
    },
    cellsProps,
    dates,
  )
}

const footerCellsProps = {
  [ColumnKey.StudentName]: { alignLeft: true, width: studentNameColumnWidth, bold: true },
  [ColumnKey.StudentClassTitle]: { alignRight: true, width: studentClassColumnWidth, bold: true },
  [ColumnKey.Total]: { alignRight: true, width: totalColumnWidth, bold: true },
}

export const createFooterCellProps = (dates: Array<SimpleDate>) => {
  return reduce(
    (acc, date) => {
      const key = createDinamicColumnKey(date)
      acc[key] = { alignRight: true, highlighted: true, bold: true }
      return acc
    },
    footerCellsProps,
    dates,
  )
}
